import * as React from 'react';
import { getPublicRuntimeConfig } from '@helpers/getPublicRuntimeConfig';

import { Translation, translations } from './generated/translations';

const LOCALE = getPublicRuntimeConfig('LOCALE');

const parseTranslation = (locale: string) => (translation: Translation) => {
  if (typeof translation === 'string') {
    if (!translations[translation] || !translations[translation][locale]) {
      return '';
    }

    return translations[translation][locale];
  }
  const { key, values } = translation;
  if (!translations?.[key]?.[locale]) {
    return '';
  }

  return Object.keys(values).reduce((acc, next) => {
    return acc.replace(`{${next}}`, (values as any)[next]);
  }, translations[key][locale]);
};

function useTranslations(config: Translation): string;
function useTranslations(config: Translation[]): string[];
function useTranslations(config: Translation | Translation[]): string | string[] {
  if (Array.isArray(config)) {
    return config.map((item) => parseTranslation(LOCALE)(item));
  }

  return parseTranslation(LOCALE)(config);
}

const Translate: React.FC<{ translation: Translation }> = React.memo(({ translation }) => {
  const output = useTranslations(translation);

  return <>{output}</>;
});

Translate.displayName = 'Translate';

export { useTranslations, Translate };
